<script>
import feedbackMixin from "@/mixins/feedback";

export default {
	name: "BaseView",
	mixins: [feedbackMixin],
	props: {
		record: {
			type: Object,
			default: {
				fieldData: {}
			}
		},
		entity: String,
		recordId: String,
		locked: Boolean
	},
	mounted: function () {
		this.$emit('set-edit-mode', {editMode: false})
	}
}
</script>

<style scoped>
.job-row > div > div {
    min-height: 24px;
}

.job-row > div > div > div {
    min-height: 24px;
}

input.form-control {
    height: 28px;
    width: 100%;
}

select.form-control {
    height: 28px;
    width: 100%;
    padding-top: 0;
    padding-bottom: 0;
}

.job-field {
    /*margin-bottom: 6px;*/
    min-height: 24px;
}

.card-header {
    min-height: 40px !important;
}
</style>